/* ---- XSS Sanitizer ---- */
function sanitizeElement(sourceEl, destEl) {
  if (!sourceEl || !destEl) return;
  /* Use DOMParser to safely parse source and copy only safe content */
  var parser = new DOMParser();
  var doc = parser.parseFromString(sourceEl.outerHTML, 'text/html');

  /* Remove dangerous tags */
  doc.querySelectorAll('script, iframe, object, embed, form').forEach(function(el) {
    el.remove();
  });

  /* Remove dangerous attributes */
  doc.querySelectorAll('*').forEach(function(el) {
    var attrs = Array.from(el.attributes);
    attrs.forEach(function(attr) {
      var name = attr.name.toLowerCase();
      var value = attr.value.toLowerCase().trim();
      if (
        name.startsWith('on') ||
        (name === 'href' && value.startsWith('javascript:')) ||
        (name === 'src' && value.startsWith('javascript:')) ||
        name === 'srcdoc'
      ) {
        el.removeAttribute(attr.name);
      }
    });
  });

  var sanitized = doc.body.querySelector(sourceEl.tagName.toLowerCase()) || doc.body.firstElementChild;
  if (sanitized) {
    destEl.innerHTML = sanitized.innerHTML;
  }
}

/* ---- VariantSelects Custom Element ---- */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.getPreOrderVariantData();
    this.updatePickupAvailability();
    this.updateContent();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll('.product-form__input--dropdown')).map(
      (select, index) => {
        /* Safe text content update - no HTML injection possible */
        select.children[0].children[1].textContent = this.options[index];
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    if (!mediaGallery) return;
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );
  }

  updateContent() {
    const variant = this.currentVariant;
    const variantID = this.currentVariant?.id ?? null;

    /* Back In Stock Notification */
    const notifyMeAvailableWrapperList = document.querySelectorAll(
      `.notify__me--available-${this.dataset.section}`
    );

    if (notifyMeAvailableWrapperList.length > 0) {
      notifyMeAvailableWrapperList.forEach((notifyMeAvailableWrapper) => {
        if (variantID != null && !variant.available) {
          const soldOutProductURL = document.querySelector('.soldout__product_url');
          if (soldOutProductURL) {
            /* Safe attribute set - no HTML injection */
            soldOutProductURL.value = `${this.dataset.origin}${this.dataset.url}?variant=${this.currentVariant.id}`;
          }
          if (notifyMeAvailableWrapper) {
            notifyMeAvailableWrapper.classList.remove('no-js-inline');
          }
        } else {
          if (notifyMeAvailableWrapper) {
            notifyMeAvailableWrapper.classList.add('no-js-inline');
          }
        }
      });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    /* Safe - only numeric variant ID is used */
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${encodeURIComponent(this.currentVariant.id)}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        /* Safe textContent - no HTML */
        input.textContent = input.getAttribute('value');
      } else {
        /* Safe textContent - no HTML */
        input.textContent = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value')
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${encodeURIComponent(this.currentVariant.id)}&section_id=${encodeURIComponent(this.dataset.section)}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const stockInventory = `inventory__stock--${this.dataset.section}`;
        const barcodeId = `barcode__${this.dataset.section}`;
        const skuId = `sku__${this.dataset.section}`;

        /* Parse fetched HTML safely */
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        /* Remove any scripts from parsed document */
        html.querySelectorAll('script, iframe, object, embed').forEach((el) => el.remove());

        /* Remove dangerous attributes from all elements */
        html.querySelectorAll('*').forEach((el) => {
          Array.from(el.attributes).forEach((attr) => {
            const name = attr.name.toLowerCase();
            const value = attr.value.toLowerCase().trim();
            if (
              name.startsWith('on') ||
              (name === 'href' && value.startsWith('javascript:')) ||
              (name === 'src' && value.startsWith('javascript:')) ||
              name === 'srcdoc'
            ) {
              el.removeAttribute(attr.name);
            }
          });
        });

        const destination = document.getElementById(id);
        const stockInventoryDestination = document.getElementById(stockInventory);
        const barcodeDestination = document.getElementById(barcodeId);
        const skuDestination = document.getElementById(skuId);

        const source = html.getElementById(id);
        const stockInventorySource = html.getElementById(stockInventory);
        const barcodeSource = html.getElementById(barcodeId);
        const skuSource = html.getElementById(skuId);

        /* Use sanitizeElement for safe innerHTML updates */
        if (source && destination) sanitizeElement(source, destination);
        if (stockInventorySource && stockInventoryDestination) sanitizeElement(stockInventorySource, stockInventoryDestination);
        if (barcodeSource && barcodeDestination) sanitizeElement(barcodeSource, barcodeDestination);
        if (skuSource && skuDestination) sanitizeElement(skuSource, skuDestination);

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('no-js-inline');

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      })
      .catch((err) => {
        console.error('[VariantSelects] renderProductInfo error:', err);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    const addButtonText = addButton.querySelector('.cart--button-text');
    if (!addButtonText) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text; /* Safe textContent */
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart; /* Safe textContent */
    }

    /* Preorder Button */
    if (window.preorder_button) {
      const productVarArray = this.PreorderVariantData;
      const variant = this.currentVariant;
      const VarInventoryManagement = this.currentVariant?.inventory_management ?? null;

      if (VarInventoryManagement != null && productVarArray) {
        for (let variant_id in productVarArray) {
          if (variant.id == variant_id) {
            const var_num = productVarArray[variant_id].qty;
            const inventoryQuantity = parseInt(var_num) || 0;
            const inventoryPolicy = productVarArray[variant_id].inventory_policy;

            if (inventoryQuantity <= 0 && inventoryPolicy === 'continue') {
              addButton.removeAttribute('disabled');
              addButtonText.textContent = window.variantStrings.preorder; /* Safe textContent */
            } else if (inventoryQuantity <= 0 && inventoryPolicy !== 'continue') {
              addButton.setAttribute('disabled', true);
              addButtonText.textContent = window.variantStrings.soldOut; /* Safe textContent */
            } else {
              addButton.removeAttribute('disabled');
              addButtonText.textContent = window.variantStrings.addToCart; /* Safe textContent */
            }
          }
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!button) return;

    const addButton = button.querySelector('[name="add"]');
    if (!addButton) return;

    const addButtonText = addButton.querySelector('.cart--button-text');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable; /* Safe textContent */
    if (price) price.classList.add('no-js-inline');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[data-variant]').textContent);
    return this.variantData;
  }

  getPreOrderVariantData() {
    try {
      const preorderElement = this.querySelector('[data-preorder]');
      if (!preorderElement) {
        this.PreorderVariantData = {};
        return;
      }

      const preorderText = preorderElement.textContent.trim();

      if (!preorderText) {
        this.PreorderVariantData = {};
        return;
      }

      this.PreorderVariantData = JSON.parse(preorderText);
    } catch (e) {
      console.warn('Failed to parse preorder variant data:', e);
      this.PreorderVariantData = {};
    }
  }
}

customElements.define('variant-selects', VariantSelects);

/* ---- VariantRadios Custom Element ---- */
class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.onColorSwatches();
  }

  onColorSwatches() {
    const variantList = this.getVariantData() || [];
    const swatchButtonList = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );
    const result = Object.values(
      variantList.reduce((total, item) => {
        const k = `${item[this.dataset.colorSwatch]}`;
        if (!total[k]) {
          total[k] = { ...item, count: 1 };
        } else {
          total[k].count += 1;
        }
        return total;
      }, {})
    );

    if (swatchButtonList.length > 0) {
      swatchButtonList.forEach((button) => {
        result.forEach((data) => {
          if (data[this.dataset.colorSwatch] === button.dataset.value) {
            if (
              this.dataset.colorSwatchStyle === 'image' &&
              data.featured_image !== null
            ) {
              /* Safe - only sets CSS custom properties and image src */
              button.setAttribute(
                'style',
                `--swatch-background-image: url(${encodeURI(data.featured_image.src)}); --swatch-background-color: ${CSS.escape ? data[this.dataset.colorSwatch] : ''};`
              );
            } else {
              button.setAttribute(
                'style',
                `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
              );
            }
          }
        });
      });
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateOptionsParent() {
    this.fieldsets.map((fieldset, index) => {
      /* Safe textContent - no HTML injection */
      fieldset.children[0].children[1].textContent = this.options[index];
    });
  }
}

customElements.define('variant-radios', VariantRadios);